<!-- Pre-login screen-size gate. The LMS needs tablet width or more, so a phone
     gets told to switch devices INSTEAD of being shown the app.

     The router outlet is genuinely removed, not hidden: leaving it mounted would
     construct the login page behind the gate — background marquee, loader gif and
     all — which is exactly the wasted effort the gate exists to prevent. Angular
     holds the pending route and activates it if the outlet reappears (rotate to
     landscape, widen the window), so nothing is lost by taking it out.

     See DeviceGateService for the thresholds and why this is pre-login only. -->
<app-device-gate *ngIf="blocked$ | async; else appShell"></app-device-gate>

<ng-template #appShell>
  <router-outlet></router-outlet>
</ng-template>
